import { getOktaAuth } from '../okta/okta-auth';

export async function getAuthHeaders() {
    const authProvider = localStorage.getItem('authProvider');

    if (authProvider === 'okta') {
        const oktaAuth = getOktaAuth();
        if (!oktaAuth) return {};

        try {
            let tokenObj = await oktaAuth.tokenManager.get('accessToken');

            if (!tokenObj || oktaAuth.tokenManager.hasExpired(tokenObj)) {
                tokenObj = await oktaAuth.tokenManager.renew('accessToken');
            }

            if (tokenObj?.accessToken) {
                return {
                    'Authorization': `Bearer ${tokenObj.accessToken}`,
                    'authentication-provider': 'okta',
                };
            }
        } catch (e) {
            console.error('Failed to get/renew Okta access token', e);
        }

        return {};
    }

    const token = localStorage.getItem('token');
    if (token) {
        return { 'Token': token };
    }
    return {};
}
